import { cloneRoute } from '@/utils/vue';

export default class History {
  /**
   * History constructor.
   * @param {Router} router
   */
  constructor(router) {
    this._router = router;
    this._lastUniqueRoute = null;
    this._currentRoute = null;
    this._tracking = true;
    this._registerTracking();
  }

  /**
   * Get current route.
   * @returns {{name, params, query}|null}
   */
  get current() {
    return this._currentRoute;
  }

  /**
   * Get last unique route.
   * @returns {{name, params, query}|null}
   */
  get lastUnique() {
    return this._lastUniqueRoute;
  }

  /**
   * Register route in history.
   * @param {Route} route
   */
  registerRoute(route) {
    if (route.name !== this._currentRoute.name) {
      this._lastUniqueRoute = cloneRoute(this._currentRoute);
    }
  }

  /**
   * Reset history tracking to original state.
   */
  resetTracking() {
    this._tracking = true;
  }

  /**
   * Set current route.
   * @param {Route} route
   */
  setCurrent(route) {
    this._currentRoute = cloneRoute(route);
  }

  /**
   * Register route tracking.
   */
  _registerTracking() {
    this._router.afterEach(to => {
      if (!this.current) {
        this.setCurrent(to);
        return;
      }

      if (this._tracking) {
        this.registerRoute(to);
      }

      this.setCurrent(to);
    });
  }
}
